import TextBlock from 'ui-component-library/components/00-Primitives/TextBlock'
import YouTube from 'ui-component-library/components/00-Primitives/YouTube'
import style from '../style.scss'

type Props = {
  captionText?: string
  youtubeVideoId: string
}

function FeaturedVideoContent(props: Props) {
  const { captionText, youtubeVideoId } = props

  return (
    <>
      <YouTube className={style.video} videoId={youtubeVideoId} />
      {captionText && (
        <TextBlock className={style.captionText}>{captionText}</TextBlock>
      )}
    </>
  )
}

export default FeaturedVideoContent
